import { msg } from "../../../../locales/translate";
export const client_registration_form_step_5 = {
	model: {
		account_holder_name: "",
		bank_name: "",
		bank_country: "",
		iban_account_number: "",
		bic_swift: "",

		currency: "EUR",
		$__currency_disabled: true,

		bank_statement_upload: "",
	},
};

export const client_registration_form_step_5_decorator = {
	model: {
		get $__account_holder_name_label() { return msg("accountHolderNameMustMatchCompanyOrAuthorisedPaymentAgentNam_5c29ab5d"); },
		get $__bank_name_label() { return msg("bankName"); },
		get $__bank_country_label() { return msg("bankCountry"); },
		$__bank_country_type: "country",
		get $__iban_account_number_label() { return msg("ibanAccountNumber"); },
		$__bic_swift_label: "BIC / SWIFT",
		get $__currency_label() { return msg("currency"); },
		$__currency_type: "select",
		get $__bank_statement_upload_label() { return msg("bankStatementOrAccountConfirmation"); },
		get $__bank_statement_upload_subtitle() { return msg("showingAccountHolderAndIban"); },
		$__bank_statement_upload_type: "file",
	},

	$__model_decorator: {
		blockless: true,
		sx: { gap: "20px" },
		blocks: [
			{
				blockless: true,
				order: ["account_holder_name"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["bank_name", "bank_country"],
			},
			{
				blockless: true,
				gridTemplateColumns: " 2fr 1fr 1fr",
				order: ["iban_account_number", "bic_swift", "currency"],
			},
			{
				blockless: true,
				order: ["bank_statement_upload"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr 1fr",
				sx: { alignItems: "end" },
				order: ["id_number", "id_country", "id_expiry_date"],
			},
		],
	},
};
